import { render, staticRenderFns } from "./businessEntitySettingsDetail.vue?vue&type=template&id=84710890&scoped=true"
import script from "./businessEntitySettingsDetail.vue?vue&type=script&lang=js"
export * from "./businessEntitySettingsDetail.vue?vue&type=script&lang=js"
import style0 from "./businessEntitySettingsDetail.vue?vue&type=style&index=0&id=84710890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84710890",
  null
  
)

export default component.exports